<script setup lang="ts">
const props = defineProps<{
    companyPub: any
    companyPri?: any
    isPrivate?: boolean
}>()

const { state } = useAppStore()

const overallScore = computed(() => {
    return props.companyPub.scores.find((item: any) => item.category === 'Overall')
})
</script>

<template>
    <div class="flex items-start gap-9">
        <div class="flex flex-col items-center">
            <div class="relative">
                <img
                    :src="`/img/treshold-empty-${useTreshold({ company: props.companyPub, score_key: 'over_100', array: true, category: 'Overall' }).treshold}.svg`"
                    alt="Treshold"
                    class="w-[104px]"
                >
                <span
                    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-semibold text-base"
                    :style="{ color: useTreshold({ company: props.companyPub, score_key: 'over_100', array: true, category: 'Overall' }).dark }"
                >
                    {{ companyPub.scores[7].over_100.toFixed(0) }}%
                </span>
            </div>
            <div
                v-if="isPrivate"
                class="max-w-[80px] flex flex-col items-center text-center text-[10px] font-bold uppercase"
                :style="{
                    color: useTreshold({ company: props.companyPub, score_key: 'over_100', array: true, category: 'Overall' }).default,
                }"
            >
                <p
                    class="fs-4xl font-semibold"
                    :style="{
                        color: useTreshold({ company: props.companyPub, score_key: 'over_100', array: true, category: 'Overall' }).dark,
                    }"
                >
                    {{ overallScore.score }}
                </p>
                <p>{{ useText(state.strings, 'sc_total_out_of') }} {{ overallScore.max_score }}</p>
                <p>{{ `(${overallScore.over_100}%)` }}</p>
            </div>
        </div>
        <p
            class="w-8/12 mt-2 fs-4xl font-semibold font-montserrat"
            :style="{
                color: useTreshold({ company: props.companyPub, score_key: 'over_100', array: true, category: 'Overall' }).default,
            }"
        >
            {{
                useTresholdName(
                    state.tresholds,
                    useTreshold(
                        {
                            company: props.companyPub,
                            score_key: 'over_100',
                            array: true,
                            category: 'Overall',
                        },
                    ).treshold,
                )
            }}
        </p>
    </div>
</template>
